// js file for product vedeo section

document.addEventListener('DOMContentLoaded', function() {
    const previewImages = document.querySelectorAll('.image-video-text-section .video-preview-image');
    const playIcons = document.querySelectorAll('.image-video-text-section .play-icon');
    
    // Function to play the media
    function playMedia(index) {
        // Hide the corresponding preview image and play icon
        if (previewImages[index]) {
            previewImages[index].style.display = 'none';
        }
        if (playIcons[index]) {
            playIcons[index].style.display = 'none';
        }

        // Select the corresponding media element
        const iframe = document.querySelector(`.video-wrapper iframe`);
        const video = document.querySelector(`.video-wrapper video`);

        if (iframe) {
            // For iframe, append autoplay parameters
            if (iframe.src.includes('?')) {
                iframe.src += '&autoplay=1&mute=1'; // Append parameters
            } else {
                iframe.src += '?autoplay=1&mute=1'; // Append parameters
            }
        } else if (video) {
          //debugger;
            // For video tag, play the video
            video.style.display = 'block'; // Show the video element
            video.play(); // Start playing the video
        }
    }

    // Add click event listeners for preview images
    previewImages.forEach(function(image, index) {
        image.addEventListener('click', function() {
            playMedia(index);
        });
    });

    // Add click event listeners for play icons
    playIcons.forEach(function(icon, index) {
        icon.addEventListener('click', function() {
            playMedia(index);
        });
    });
});

